import { DetailedHTMLProps, FC, InputHTMLAttributes } from 'react'
import { Block } from './styled'

const ContentBlock: FC<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = ({ children, ...rest }) => <Block {...rest}>{children}</Block>

export default ContentBlock
